import { render, staticRenderFns } from "./ResizableCreator.vue?vue&type=template&id=10f828fd&scoped=true&"
import script from "./ResizableCreator.vue?vue&type=script&lang=ts&"
export * from "./ResizableCreator.vue?vue&type=script&lang=ts&"
import style0 from "./ResizableCreator.vue?vue&type=style&index=0&id=10f828fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f828fd",
  null
  
)

export default component.exports